import React, { useState } from "react";
import { DownloadOutlined, DescriptionOutlined } from "@mui/icons-material";

export default function Newsletter() {
  const [downloading, setDownloading] = useState(false);

  const handleDownloadNewsletter = async () => {
    try {
      setDownloading(true);

      // Create a link element and trigger download
      const link = document.createElement("a");
      link.href = "/assets/NEWS LETTER 2025 DEC BREAK.pdf";
      link.download = "PETANNS_Newsletter_December_2025.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading newsletter:", error);
      alert("Error downloading newsletter. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="w-full bg-gradient-to-br from-slate-50 to-blue-50 min-h-screen">
      <div className="container mx-auto px-4 py-8 pb-20 max-w-4xl">
        {/* Newsletter Download Section */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 md:p-12">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <DescriptionOutlined sx={{ fontSize: 40, color: "#2563eb" }} />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2">
              PETANNS TECHNICAL COLLEGE
            </h1>
            <h2 className="text-xl md:text-2xl font-semibold text-blue-600 mb-4">
              ✨ End-of-Year Newsletter – 2025 Edition
            </h2>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto">
              Download our comprehensive end-of-year newsletter featuring
              academic achievements, student highlights, and important updates
              for the 2025 academic year.
            </p>
          </div>

          {/* Newsletter Information */}
          <div className="mb-8">
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-100">
              <h3 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
                <span className="text-blue-600 mr-3">📋</span>
                What's Inside This Newsletter
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700">
                <div className="flex items-start">
                  <span className="text-blue-600 mr-2 mt-1">•</span>
                  <span>Academic achievements and examination results</span>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-600 mr-2 mt-1">•</span>
                  <span>Skills training and innovation highlights</span>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-600 mr-2 mt-1">•</span>
                  <span>Industry partnerships and community engagement</span>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-600 mr-2 mt-1">•</span>
                  <span>Student life and co-curricular activities</span>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-600 mr-2 mt-1">•</span>
                  <span>Infrastructure improvements and growth</span>
                </div>
                <div className="flex items-start">
                  <span className="text-blue-600 mr-2 mt-1">•</span>
                  <span>Important term dates and announcements</span>
                </div>
              </div>
            </div>
          </div>

          {/* Download Section */}
          <div className="text-center">
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl p-8 text-white mb-6">
              <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-4">
                <DownloadOutlined sx={{ fontSize: 32, color: "white" }} />
              </div>
              <h3 className="text-2xl font-bold mb-2">Download Newsletter</h3>
              <p className="text-blue-100 mb-6 max-w-md mx-auto">
                Get the complete newsletter with all details, images, and
                formatting in PDF format.
              </p>
              <button
                onClick={handleDownloadNewsletter}
                disabled={downloading}
                className={`inline-flex items-center px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 ${
                  downloading
                    ? "bg-white bg-opacity-50 cursor-not-allowed"
                    : "bg-white text-blue-600 hover:bg-gray-100 hover:shadow-lg transform hover:scale-105"
                }`}
              >
                {downloading ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-2 border-blue-600 border-t-transparent mr-3"></div>
                    Downloading...
                  </>
                ) : (
                  <>
                    <DownloadOutlined sx={{ fontSize: 24, marginRight: 1 }} />
                    Download PDF Newsletter
                  </>
                )}
              </button>
            </div>

            {/* File Information */}
            <div className="bg-gray-50 rounded-lg p-4 text-sm text-gray-600">
              <div className="flex items-center justify-center space-x-6">
                <div className="flex items-center">
                  <span className="font-medium mr-1">Format:</span>
                  <span>PDF</span>
                </div>
                <div className="flex items-center">
                  <span className="font-medium mr-1">Size:</span>
                  <span>~2-3 MB</span>
                </div>
                <div className="flex items-center">
                  <span className="font-medium mr-1">Pages:</span>
                  <span>Multiple</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
